module.exports = __webpack_public_path__ + "media/src/assets/images/img-travel-aurora-e06dac83a3da7411f390166e3b5bba02.png";